import * as React from "react";
import { Tree, TreeItem, TreeItemLayout } from "@fluentui/react-components";
import apiServices from "../../service";
import OverlayLoader from "../../components/OverlayLoader";

interface TreeNode {
  items?: TreeNode[];
  subModule?: string;
  fields?: string;
  module?: string;
  fieldName?: string;
}

interface TreeComProps {
  onSelect: (module: string) => void;
  excludedItems: string[];
  selectedPath: string | null;
}

const RenderTreeItems = (
  items: TreeNode[],
  onSelect: (
    fields: string,
    fullPath: string,
    customPath: string,
    ModuleFields?: string,
    Fields?: string,
    trimmedPath?: string,
    fieldName?: string
  ) => void,
  excludedItems: string[],
  selectedField: string | null,
  parentPath: string = ""
) => {
  if (!Array.isArray(items)) {
    console.warn("Expected items to be an array, but got:", items);
    return null;
  }

  return items.map((item: any, index) => {
    // const isExcluded = excludedItems.some(
    //   (text) => text.includes(item.fields) || text.includes(item.fieldName)
    // );
    const fullPath = parentPath
      ? `${parentPath} - ${item.module || item.subModule || item.fields || ""}`
      : item.module || item.subModule || item.fields || "";
    const isSelected = selectedField === item.fields;

    const isExcluded = excludedItems.includes(fullPath);

    if (isExcluded) return null;

    const isBranch = item.items && item.items.length > 0;

    const ModuleFields = item.module;
    const Fields = item.fields;

    // Use 'let' for trimmedPath to allow reassignment
    let trimmedPath = parentPath;
    if (trimmedPath) {
      trimmedPath = trimmedPath.split(" - ")[0].trim(); // Correctly reassign the trimmedPath
    }

    const customPath = trimmedPath
      ? `${trimmedPath} - ${item.fields}`
      : `${item.fields}`;

    return (
      <TreeItem key={index} itemType={isBranch ? "branch" : "leaf"}>
        <TreeItemLayout
          onClick={() => {
            const field = item.fieldName || item.fields || "";
            onSelect(
              field,
              fullPath,
              customPath,
              ModuleFields,
              Fields,
              trimmedPath,
              item.fieldName
            );
          }}
          style={{
            background:
              selectedField === (item.fieldName || item.fields)
                ? "#eee"
                : "transparent",
          }}
        >
          {isBranch ? item.module || item.subModule : item.fields}
        </TreeItemLayout>

        {isBranch && item.items && (
          <Tree>
            {RenderTreeItems(
              item.items,
              onSelect,
              excludedItems,
              selectedField,
              fullPath
            )}
          </Tree>
        )}
      </TreeItem>
    );
  });
};

export const Default = ({
  onSelect,
  excludedItems,
  selectedField,
}: {
  onSelect: (
    fields: string,
    fullPath: string,
    customPath: string,
    ModuleFields?: string,
    Fields?: string,
    trimmedPath?: string
  ) => void;
  excludedItems: string[];
  selectedField: string | null;
}) => {
  const [treeData, setTreeData] = React.useState<TreeNode[]>([]);
  const [isLoading, setLoading] = React.useState<boolean>(false);

  const getExportList = () => {
    setLoading(true);
    apiServices.exportExcel
      .getFields()
      .then((res) => {
        const response = res.data?.data;
        setTreeData(response);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getExportList();
  }, []);

  return (
    <>
      <OverlayLoader isLoading={isLoading} />
      <Tree aria-label="Dynamic Tree">
        {RenderTreeItems(treeData, onSelect, excludedItems, selectedField)}
      </Tree>
    </>
  );
};
